import React, { useEffect, useState } from "react";
import Breadcrumb from "../../../components/Breadcrumb";
import { SOCIETY_MANAGEMENT } from "../../../Routing/routes";
import SocietyListLayer from "./Component/SocietyListLayer";
import { getCommunities } from "../../../redux/actions/SocietyController/CtrlCommunityManagementAction/CtrlCommunityManagement";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";


const columns = [
    { id: "slNo", label: "#", sort: false, width: "50px" },
    { id: "id", label: "Community ID", sort: true, width: "120px" },
    { id: "type", label: "Community Type", sort: true, width: "200px" },
    { id: "title", label: "Community Title", sort: true, width: "200px" },
    { id: "createdAt", label: "Created Date", sort: true, width: "150px" },
    { id: "members", label: "Flat & Members", sort: false, width: "170px" },
    { id: "status", label: "Status", sort: true, width: "110px" },
    { id: "action", label: "Action", sort: false, width: "150px" },
];

const SocietyMangement = () => {
    const links = [{ to: SOCIETY_MANAGEMENT, text: 'Society Management' }]
    const { loading, communityData } = useSelector(state => state.CtrlCommunityManagementReducers)

    const dispatch = useDispatch()
    const [searchQuery, setSearchQuery] = useState({ page: 1, limit: 10, search: '', status: null })

    // eslint-disable-next-line no-unused-vars
    const _handlePageChange = (currentPage) => {
        if (searchQuery.page !== currentPage) {
            setSearchQuery({ ...searchQuery, page: currentPage })
        }
    }
    // eslint-disable-next-line no-unused-vars
    const _handleLimitChange = (e) => {
        setSearchQuery({ ...searchQuery, page: 1, limit: e.target.value })
    }
    // eslint-disable-next-line no-unused-vars
    const _handleSearch = (e) => {
        e.preventDefault();
        setSearchQuery({ ...searchQuery, page: 1, search: e.target.value })
    }
    // eslint-disable-next-line no-unused-vars
    const _handleStatusChange = (e) => {
        setSearchQuery({ ...searchQuery, page: 1, status: e.target.value })
    }
    // eslint-disable-next-line no-unused-vars
    const _handleRefresh = () => {
        setSearchQuery({ ...searchQuery, page: 1, search: '', status: null })
    }

    const getTableData = () => {
        const isAll = (v) => !v || v === 'all';
        dispatch(getCommunities({
            page: searchQuery?.page || 1,
            limit: searchQuery?.limit || 10,
            search: searchQuery?.search || '',
            status: isAll(searchQuery?.status) ? null : searchQuery.status,
            type: isAll(searchQuery?.type) ? null : searchQuery.type,
        }))
    }
    useEffect(() => {
        getTableData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchQuery]);
    return (
        <>
            <Breadcrumb replaceClass="mb-24" description='View and Manage Community' links={links} headingTitle="Community Management" />
            <SocietyListLayer data={communityData?.data?.length ? communityData?.data?.map((item, index) => {
                return {
                    slNo: index + 1 + Number((communityData?.meta?.pagination?.page - 1) * communityData?.meta?.pagination?.limit),
                    id: item.society_id,
                    type: item?.type || '-',
                    title: item.name,
                    createdAt: item.created_at,
                    // GET /api/societies returns these aggregates per society
                    flats: Number(item.active_flats) || 0,
                    members: Number(item.total_members) || 0,
                    owners: Number(item.owners_count) || 0,
                    tenants: Number(item.tenants_count) || 0,
                    // ACTIVE | INACTIVE | SUSPENDED | UNDER_REVIEW — is_active stays 1 for all of them
                    status: item.status,
                    action: item.society_id
                };
            }) : []} columns={columns} page={communityData?.meta?.pagination?.page || 1} limit={communityData?.meta?.pagination?.limit || 10} total={communityData?.meta?.pagination?.total} loading={loading} getTableData={getTableData} searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
        </>
    );
};

export default SocietyMangement;
